import React from 'react';
import classNames from 'classnames/bind';
import styles from './info.scss';
const cx = classNames.bind(styles);

const PolicyContent = React.memo(({ fontSize = '14px' }) => {
  // return (
  //   <div className={cx('info')}>
  //     <ReactMarkdown source={source} />
  //   </div>
  // );

  return (
    <div className={cx('info')} style={{ fontSize }}>
      <h1>닥터뮤지 개인정보 처리방침 </h1>
      <p>
        주식회사 퀄슨의 닥터뮤지(Dr.muzy)는 정보통신망 이용촉진 및 정보보호 등에
        관한 법률(이하 ‘정보통신망법’) 및 개인정보보호법에 따라 이용자의
        개인정보 보호 및 권익을 보호하고 개인정보와 관련한 이용자의 고충을
        원활하게 처리할 수 있도록 다음과 같은 처리방침을 두고 있습니다. 닥터뮤지
        개인정보 처리방침을 개정하는 경우, 서비스 내 또는 그 연결화면(또는
        개별공지)을 통하여 공지할 것입니다.
      </p>
      <h3>1. 개인정보의 처리 목적 </h3>
      <p>
        닥터뮤지 서비스의 회원관리, 서비스 개발·제공 및 향상 등 아래의
        목적으로만 개인정보를 처리합니다. 처리한 개인정보는 목적 이외의 용도로는
        사용되지 않으며 이용 목적이 변경될 시에는 사전동의를 구할 예정입니다.
        회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격
        유지·관리, 서비스 부정이용 방지, 각종 고지·통지, 고충처리, 분쟁 조정을
        위한 기록 보존 등을 목적으로 개인정보를 처리합니다. 콘텐츠 등 기존
        서비스 제공(광고 포함)에 더하여, 인구통계학적 분석, 서비스 방문 및
        이용기록의 분석 등에 기반한 맞춤형 서비스 제공 등 신규 서비스 요소의
        발굴 및 기존 서비스 개선 등을 위하여 개인정보를 이용합니다. 관련법령 및
        이용약관을 위반하는 회원에 대한 이용 제한 조치, 부정 이용 행위를
        포함하여 서비스의 원활한 운영에 지장을 주는 행위에 대한 방지 및 제재,
        계정도용 및 부정거래 방지, 약관 개정 등의 고지사항 전달, 분쟁조정을 위한
        기록 보존, 민원처리 등 이용자 보호 및 서비스 운영을 위하여 개인정보를
        이용합니다. 유료 서비스 제공에 따르는 본인인증, 구매 및 요금 결제, 상품
        및 서비스의 배송을 위하여 개인정보를 이용합니다. 이벤트 정보 및 참여기회
        제공, 광고성 정보 제공 등 마케팅 및 프로모션 목적으로 개인정보를
        이용합니다. 서비스 이용기록과 접속 빈도 분석, 서비스 이용에 대한 통계,
        서비스 분석 및 통계에 따른 맞춤 서비스 제공 및 광고 게재 등에 개인정보를
        이용합니다. 보안, 프라이버시, 안전 측면에서 이용자가 안심하고 이용할 수
        있는 서비스 이용환경 구축을 위해 개인정보를 이용합니다.
      </p>
      <h3>2. 개인정보의 처리 및 보유 기간</h3>
      <p>
        ① 닥터뮤지는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터
        개인정보를 수집 시에 동의 받은 개인정보 보유·이용기간 내에서 개인정보를
        처리·보유합니다. ② 이용자의 개인정보는 개인정보의 수집목적 또는 제공받은
        목적이 달성되면 파기됩니다. 회원 탈퇴 및 계정 삭제 시, 수집된 개인정보는
        완전히 삭제되며 어떠한 용도로도 이용할 수 없도록 처리됩니다. 단, 아래
        항목에 해당하는 경우에는 명시한 기간 동안 보관할 수 있으며, 그 외 다른
        목적으로는 사용하지 않습니다. 불건전한 서비스 이용으로 서비스에 물의를
        일으킨 이용자의 경우 사법기관 수사의뢰를 하거나 다른 회원을 보호할
        목적으로 1년간 해당 개인정보를 보관할 수 있습니다. 관계법령의 규정에
        의하여 보관할 필요가 있는 경우 회사는 수집 및 이용 목적 달성 후에도
        관계법령에서 정한 일정 기간 동안 회원의 개인정보를 보관할 수 있습니다.
        전자상거래 등에서 소비자 보호에 관한 법률
        <br />
        계약 또는 청약철회 등에 관한 기록: 5년
        <br />
        대금결제 및 재화의 공급에 관한 기록: 5년
        <br />
        소비자의 불만 또는 분쟁처리에 관한 기록: 3년
        <br />
        전자금융거래법
        <br />
        전자금융에 관한 기록: 5년
        <br />
        특정 금융거래정보의 보고 및 이용 등에 관한 법률
        <br />
        금융거래정보: 5년
      </p>
      <h3>3. 개인정보 처리의 위탁</h3>
      <p>
        ① 닥터뮤지는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보
        처리업무를 위탁하고 있습니다.
        <table className="i_table">
          <tr>
            <th width="30%">위탁받는 자(수탁자)</th>
            <th>위탁하는 업무의 내용</th>
          </tr>
          <tr>
            <td>(주)엘지유플러스</td>
            <td>구매 및 요금 결제, 고지사항 전달, 문자 메시지(SMS/MMS) 발송</td>
          </tr>
          <tr>
            <td>효성에프엠에스(주)</td>
            <td>구매 및 요금 결제, 고지사항 전달</td>
          </tr>
          <tr>
            <td>(주)제인테크</td>
            <td>서비스 물품 및 이벤트 경품 배송 등의 물류 업무</td>
          </tr>
          <tr>
            <td>(주)한진택배</td>
            <td>서비스 물품 및 이벤트 경품 배송 등의 물류 업무</td>
          </tr>
          <tr>
            <td>㈜트랜스코스모스코리아</td>
            <td>
              마케팅 및 이벤트, 광고, 수강 안내 등의 정보 전달, 결제 정보 수집
              및 진행, 관련 민원 처리
            </td>
          </tr>
          <tr>
            <td>(주)마크티</td>
            <td>어학기 관련 CS처리, AS업무</td>
          </tr>
          <tr>
            <td>시노텍코리아(주)</td>
            <td>이지펜 관련 CS처리, AS업무</td>
          </tr>
          <tr>
            <td>NHN</td>
            <td>
              정보성 메시지 카카오톡 알림톡 발송 업무 및 톡 기반 상담 서비스
            </td>
          </tr>
        </table>
        ② 닥터뮤지는 위탁계약 체결시 개인정보 보호법 제25조에 따라 위탁업무
        수행목적 외 개인정보 처리금지, 기술적․관리적 보호조치, 재위탁 제한,
        수탁자에 대한 관리․감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에
        명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
        <br />③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본
        개인정보 처리방침을 통하여 공개하도록 하겠습니다.
      </p>
      <h3>4. 정보주체와 법정대리인의 권리·의무 및 그 행사방법 </h3>
      <p>이용자는 개인정보주체로써 다음과 같은 권리를 행사할 수 있습니다.</p>
      <p>
        ① 정보주체는 퀄슨에 대해 언제든지 개인정보 열람, 정정, 삭제, 처리정지
        요구 등의 권리를 행사할 수 있습니다.
        <br />
        ② 제1항에 따른 권리 행사는 퀄슨에 대해 개인정보 보호법 시행령
        제41조제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수
        있으며 퀄슨은 이에 대해 지체 없이 조치하겠습니다.
        <br />
        ③ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등
        대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지
        제11호 서식에 따른 위임장을 제출하셔야 합니다.
        <br />
        ④ 개인정보 열람 및 처리정지 요구는 개인정보보호법 제35조 제5항, 제37조
        제2항에 의하여 정보주체의 권리가 제한 될 수 있습니다.
        <br />
        ⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집
        대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.
        <br />⑥ 퀄슨은 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구,
        처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를
        확인합니다.
      </p>
      <h3>5. 처리하는 개인정보의 항목</h3>
      <p>
        ① 닥터뮤지는 다음의 개인정보 항목을 처리하고 있습니다.
        <table className="i_table">
          <tr>
            <th>이용 목적</th>
            <th>필수 여부</th>
            <th>수집 항목</th>
          </tr>
          <tr>
            <td>회원가입 및 서비스 이용</td>
            <td>필수</td>
            <td>이메일 주소, 비밀번호, 휴대전화번호</td>
          </tr>
          <tr>
            <td>이용권 구매</td>
            <td>필수</td>
            <td>
              결제수단 소유자 정보(이름), 수취인 이름, 배송주소, 배송연락처,
              신용카드, 은행계좌번호 등 결제 수단 정보
            </td>
          </tr>
          <tr>
            <td>AI 홈어학기 이용</td>
            <td>필수</td>
            <td>
              서비스 실행 및 청취 모드 상태에서의 이용자 음성 명령 언어 정보
            </td>
          </tr>
          <tr>
            <td>상담 신청</td>
            <td>선택</td>
            <td>이름, 휴대전화번호</td>
          </tr>
          <tr>
            <td>마케팅 (이벤트, 프로모션)</td>
            <td>선택</td>
            <td>이름, 휴대전화번호, 생년월일, 성별, 이메일 주소</td>
          </tr>
          <tr>
            <td colSpan="2">서비스 이용시 생성되어 수집되는 정보</td>
            <td>
              IP주소, 서비스 이용기록, 접속시간 등 로그, 쿠키,
              모바일기기정보(OS버전, 광고식별자 등) 등
            </td>
          </tr>
        </table>
      </p>
      <h3>6. 개인정보의 파기</h3>
      <p>
        닥터뮤지는 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체없이 해당
        개인정보를 파기합니다. 파기의 절차, 기한 및 방법은 다음과 같습니다.
        파기절차 이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의
        경우 별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후
        혹은 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한 경우가
        아니고서는 다른 목적으로 이용되지 않습니다. 파기기한 이용자의 개인정보는
        개인정보의 보유기간이 경과된 경우에는 보유기간의 종료일로부터 5일
        이내에, 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그
        개인정보가 불필요하게 되었을 때에는 개인정보의 처리가 불필요한 것으로
        인정되는 날로부터 5일 이내에 그 개인정보를 파기합니다. 파기방법 전자적
        파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다.
        종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
      </p>
      <h3>7. 개인정보 자동 수집 장치의 설치•운영 및 거부에 관한 사항</h3>
      <p>
        ① 닥터뮤지는 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고
        수시로 불러오는 ‘쿠키(cookie)’를 사용합니다. ② 쿠키는 웹사이트를
        운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는
        소량의 정보이며 이용자들의 PC 컴퓨터 내의 하드디스크에 저장되기도
        합니다. 쿠키의 사용 목적 이용자가 방문한 각 서비스와 웹 사이트들에 대한
        방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게
        최적화된 정보 제공을 위해 사용됩니다. 쿠키의 설치•운영 및 거부
        웹브라우저 상단의 도구>인터넷 옵션>개인정보 메뉴의 옵션 설정을 통해 쿠키
        저장을 거부 할 수 있습니다. 다. 쿠키 저장을 거부할 경우 맞춤형 서비스
        이용에 어려움이 발생할 수 있습니다.
      </p>
      <h3>8. 개인정보 보호 책임자</h3>
      <p>
        ① 닥터뮤지는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보
        처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이
        개인정보 보호 책임자를 지정하고 있습니다.
        <br />
        개인정보 보호 책임자 <br />
        이름: 최기웅
        <br />
        이메일: choi@qualson.com
        <br />
        FAX: 02-6455-3602
        <br />
        개인정보 보호 담당자
        <br />
        성명: 곽재상
        <br />
        이메일: js.kwak@qualson.com
        <br />
        FAX: 02-6455-3602
        <br />② 정보주체께서는 닥터뮤지의 서비스를 이용하시면서 발생한 모든
        개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보
        보호 책임자 및 담당부서로 문의하실 수 있습니다. 닥터뮤지는 정보주체의
        문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.
      </p>
      <h3>9. 개인정보 처리방침 변경</h3>
      <p>
        ① 이 개인정보 처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른
        변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터
        서비스 내 또는 그 연결화면(또는 개별공지)을 통하여 고지할 것입니다.
      </p>
      <h3>10. 개인정보의 안전성 확보 조치</h3>
      <p>
        닥터뮤지는 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한
        기술적/관리적 및 물리적 조치를 하고 있습니다. 정기적인 자체 감사 실시
        개인정보 취급 관련 안정성 확보를 위해 정기적(분기 1회)으로 자체 감사를
        실시하고 있습니다. 개인정보 취급 직원의 최소화 및 교육 개인정보를
        취급하는 직원을 지정하고 담당자에 한정시켜 최소화 하여 개인정보를
        관리하는 대책을 시행하고 있습니다. 내부관리계획의 수립 및 시행
        개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고
        있습니다. 해킹 등에 대비한 기술적 대책 닥터뮤지는 해킹이나 컴퓨터
        바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을
        설치하고 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에
        시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.
        개인정보의 암호화 이용자의 개인정보는 비밀번호는 암호화 되어 저장 및
        관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송
        데이터를 암호화 하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을
        사용하고 있습니다. 개인정보에 대한 접근 제한 개인정보를 처리하는
        데이터베이스시스템에 대한 접근권한의 부여, 변경, 말소를 통하여
        개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며
        침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.
      </p>
    </div>
  );
});

export default PolicyContent;

// const source = `
// # hello, This is Markdown Live Preview

// ----
// ## what is Markdown?
// see [Wikipedia](https://en.wikipedia.org/wiki/Markdown)

// > Markdown is a lightweight markup language, originally created by John Gruber and Aaron Swartz allowing people "to write using an easy-to-read, easy-to-write plain text format, then convert it to structurally valid XHTML (or HTML)".

// ----
// ## usage
// 1. Write markdown text in this textarea.
// 2. Click 'HTML Preview' button.

// ----
// ## markdown quick reference
// # headers

// *emphasis*

// **strong**

// * list

// >block quote

//     code (4 spaces indent)
// [links](https://wikipedia.org)

// ----
// ## changelog
// * 17-Feb-2013 re-design

// ----
// ## thanks
// * [markdown-js](https://github.com/evilstreak/markdown-js)
// `;
